import React, { useState } from "react";
import { ChevronDown, ChevronRight } from "lucide-react";
import sampleImage from "../assets/Blackwomen/BWI26.jpg"; // Consider replacing with an image showing an app or code

const AccordionItem = ({ title, children, isOpen, onClick }) => (
  <div className="border-b border-gray-200">
    <button
      onClick={onClick}
      className="w-full text-left py-4 px-6 flex items-center justify-between bg-[#F3FAF9] hover:bg-[#e6f1f0] transition-colors"
    >
      <span className="uppercase text-sm tracking-wide text-gray-700">{title}</span>
      {isOpen ? <ChevronDown size={18} /> : <ChevronRight size={18} />}
    </button>
    {isOpen && <div className="px-6 pb-4 text-gray-700 text-sm">{children}</div>}
  </div>
);

export default function LaunchGlowUp() {
  const [openIndex, setOpenIndex] = useState(0); // Start with first open

  const toggleIndex = (index) => setOpenIndex((prev) => (prev === index ? null : index));

  return (
    <div className="max-w-6xl mx-auto mt-12 px-4 grid grid-cols-1 md:grid-cols-2 gap-10 items-start mb-20">
 {/* Right Side - Image */}
      <div className="w-full py-24">
        <img
          src={sampleImage}
          alt="Woman working on a custom web application"
          className="shadow-xl w-full h-[500px] object-cover"
        />
      </div>
      {/* Left Side - Content & Accordion */}
      <div>
        <p className="uppercase text-sm text-[#c6884a] tracking-widest mb-2">Custom Web Application MVP</p>
        <h1 className="text-4xl  text-gray-900 mb-4">The Launch Glow-Up</h1>
        <p className="text-gray-700 mb-8">
          For women entrepreneurs ready to launch their first custom web application or a powerful Minimum Viable Product (MVP).
        </p>

        <div className="border border-gray-200 rounded overflow-hidden shadow-sm">
          <AccordionItem
            title="What's Included"
            isOpen={openIndex === 0}
            onClick={() => toggleIndex(0)}
          >
            <ul className="list-disc list-inside space-y-1">
              <li>60-min App Discovery & Strategy Session</li>
              <li>Custom-coded 5-screen MVP application (built with React, Tailwind, Firebase)</li>
              <li>Secure User Authentication (login/signup)</li>
              <li>Responsive design for all devices</li>
              <li>Foundational SEO for app visibility</li>
              <li>Basic data management setup (Firebase Firestore)</li>
              <li>2 rounds of feature/design revisions</li>
              <li>Deployment to Firebase Hosting + 30-min training call</li>
            </ul>
          </AccordionItem>

          <AccordionItem
            title="Requirements/Not Included"
            isOpen={openIndex === 1}
            onClick={() => toggleIndex(1)}
          >
            <ul className="list-disc list-inside space-y-1">
              <li>Complex custom API integrations</li>
              <li>Extensive data migration</li>
              <li>Ongoing app maintenance plans (available separately)</li>
              <li>Paid third-party service subscriptions (e.g., advanced analytics tools)</li>
            </ul>
          </AccordionItem>

          <AccordionItem
            title="Timeline"
            isOpen={openIndex === 2}
            onClick={() => toggleIndex(2)}
          >
            <p>Typical turnaround is 4–6 weeks from project start date, depending on client responsiveness and scope finalization.</p>
          </AccordionItem>

          <AccordionItem
            title="Project Investment"
            isOpen={openIndex === 3}
            onClick={() => toggleIndex(3)}
          >
            <p className="mb-3">Base Investment: $3,000</p>
            <ul className="list-disc list-inside space-y-1 mb-4">
              <li>30% non-refundable deposit due at time of signing contract</li>
              <li>35% due at the start of your project</li>
              <li>35% due 30 days after start date</li>
            </ul>
            <p className="font-semibold mt-4 mb-2">Available Add-Ons:</p>
            <ul className="list-disc list-inside space-y-1">
              <li>Additional custom app screens/features (quoted per scope)</li>
              <li>Enhanced SEO & App Store Optimization (ASO) strategy (+$1,200)</li>
              <li>Basic CRM integration (e.g., connecting to a simple client list) (+$1,000)</li>
            </ul>
          </AccordionItem>
        </div>

        {/* Investment CTA */}
        <div className="mt-6 flex flex-col sm:flex-row sm:items-center sm:gap-6 gap-3">
          <p className="text-gray-700 text-lg">
            <span className="italic">Investment begins at:</span>{' '}
            <span className="text-2xl text-gray-900  font-medium">$3,000</span>
          </p>
           <a href="/contact">
          <button className="bg-[#C18343] text-white uppercase tracking-widest px-6 py-3 text-sm hover:bg-[#a76e33] transition-colors">
            BOOK NOW
          </button>
          </a>
        </div>
      </div>

     
    </div>
  );
}